// src/pages/SetPassword.jsx (New for Workflow)
import React, { useState, useEffect } from 'react';
import { api } from '../utilities/api';
import { validatePassword } from '../utilities/utilities';

function SetPassword({ onSuccess, setLoading, setError, initialData }) {
  const [formData, setFormData] = useState({ ...initialData, password: '', confirmPassword: '' });
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    setFormData(prev => ({
      ...prev,
      ...initialData,
      password: '',
      confirmPassword: '',
    }));
  }, [initialData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (formData.password !== formData.confirmPassword) {
      setError('Passwords do not match.');
      return;
    }
    
    const pwdError = validatePassword(formData.password);
    if (pwdError) {
      setError(pwdError);
      return;
    }

    if (!initialData.userid) {
      setError('User information is missing. Cannot set password.');
      return;
    }

    const apiData = {
      "registration_step" : "password",
      "password" : formData.password 
    }

    setIsSubmitting(true);
    setLoading(true);
    try {
      const result = await api.updateUserInfo(apiData);
      if (result.success) { // Assuming API returns { success: true }
        onSuccess(result?.jwt ? { jwt: result.jwt } : {}); // Signal success to parent workflow
      } else {
        setError(result.errorMsg || 'Failed to set password. Please try again.');
      }
    } catch {
      setError('An error occurred while setting the password.');
    } finally {
      setIsSubmitting(false);
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <h3 className="text-lg font-semibold text-primary mb-4">Create Your Password</h3>
      <div>
        <label htmlFor="password" className="block text-sm font-medium text-neutral-dark mb-1">New Password</label>
        <input
          id="password"
          name="password"
          type="password"
          placeholder="Enter new password"
          value={formData.password}
          onChange={handleChange}
          className="w-full p-2 border border-neutral rounded focus:outline-none focus:ring-2 focus:ring-primary"
          required
          disabled={isSubmitting}
        />
      </div>
      <div>
        <label htmlFor="confirmPassword" className="block text-sm font-medium text-neutral-dark mb-1">Confirm New Password</label>
        <input
          id="confirmPassword"
          name="confirmPassword"
          type="password"
          placeholder="Confirm new password"
          value={formData.confirmPassword}
          onChange={handleChange}
          className="w-full p-2 border border-neutral rounded focus:outline-none focus:ring-2 focus:ring-primary"
          required
          disabled={isSubmitting}
        />
      </div>
      {/* Use shared navigation buttons from parent? Or keep step-specific button? */}
      {/* Using step-specific button for clarity here */}
      <div className="pt-4">
        <button
          type="submit"
          className={`w-full bg-button text-white py-2 rounded-md hover:bg-button-light transition duration-200 ${isSubmitting ? 'opacity-50 cursor-not-allowed' : ''}`}
          disabled={isSubmitting}
        >
          {isSubmitting ? 'Saving...' : 'Save Password & Continue'}
        </button>
      </div>
       {/* Add a "Back" button if needed, calling onBack */}
       {/* <button type="button" onClick={onBack} disabled={isSubmitting}>Back</button> */}

    </form>
  );
}

export default SetPassword;
